import { render, staticRenderFns } from "./voucher_card.vue?vue&type=template&id=63c444b7&"
import script from "./voucher_card.vue?vue&type=script&lang=js&"
export * from "./voucher_card.vue?vue&type=script&lang=js&"
import style0 from "./voucher_card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue/rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports